import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242526",
      "fill-rule": "evenodd",
      d: "M1.088 13.607q.186.33.559.329h12.706q.374 0 .559-.33a.59.59 0 0 0-.018-.648L8.541 2.367A.6.6 0 0 0 8 2.064a.61.61 0 0 0-.542.303l-6.353 10.59a.59.59 0 0 0-.018.65Zm5.787-1.868L8 10.614l1.125 1.125a.37.37 0 0 0 .275.113q.162 0 .275-.113a.37.37 0 0 0 .113-.275q0-.162-.113-.275L8.55 10.064 9.675 8.94a.37.37 0 0 0 .113-.275q0-.162-.113-.275a.37.37 0 0 0-.275-.112q-.162 0-.275.112L8 9.514 6.875 8.39a.37.37 0 0 0-.275-.112q-.162 0-.275.112a.37.37 0 0 0-.112.275q0 .163.112.275l1.125 1.125-1.125 1.125a.37.37 0 0 0-.112.275q0 .163.112.275a.37.37 0 0 0 .275.113q.162 0 .275-.113Z",
      class: "change-color-fill",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }